import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {inject} from "@angular/core";
import {LipoRouteEnum} from "../../shared/enums/lipo-route.enum";
import {AuthGuardData, createAuthGuard} from "keycloak-angular";
import {RealmService} from '../services/realm.service';
import Keycloak from "keycloak-js";

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const {authenticated} = authData;
  const realmService = inject(RealmService);
  const keycloakService = inject(Keycloak);

  if (authenticated) {
    return router.parseUrl(LipoRouteEnum.HOME)
  }

  if (keycloakService.realm && keycloakService.realm.length > 0) {
    await keycloakService.login({
      redirectUri: window.location.origin + LipoRouteEnum.HOME,
      loginHint: realmService.mail ?? '',
      prompt: 'login'
    })
  }

  return true;
};

export const realmGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
